import { Flex, FormControl } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { MdClose } from 'react-icons/md'
import Modal from 'react-modal'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { TextAreaCmp } from '../../../../../components/TextareaCmp'
import { iTextoAjuda } from '../ModalIA'
import { WhiteModal } from './styles'

interface iModalProps {
  isOpen: boolean
  onCreate: (obj: iTextoAjuda) => void
  onClose: () => void
  obj: iTextoAjuda
}

export const ModalTextoApoio: React.FC<iModalProps> = ({ isOpen, onClose, onCreate, obj }) => {
  const [Item, setItem] = useState<iTextoAjuda>()

  useEffect(() => {
    setItem(obj)
  }, [obj])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content-default"
    >
      <WhiteModal>
        <FormControl as={Flex} flexDir="column" gap="1rem">
          <Flex justifyContent={'space-between'}>
            <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--Azul)' }}>
              Gerar informações sobre o cargo com IA
            </h3>
            <Flex color='var(--Red)' _hover={{ color: 'var(--Red-hover)' }}>
              <MdClose cursor={'pointer'} size={18} onClick={onClose}/>
            </Flex>
          </Flex>

          {Item && <Flex flexDir={'column'} gap="1rem">
            <TextAreaCmp
              label='Insira um texto de apoio aqui para a IA'
              value={Item.texto}
              height={'10rem'}
              OnChange={(val) => setItem({ ...Item, texto: val })}
            />
          </Flex>}
        </FormControl>

        <Flex justifyContent="end" gap=".375rem" mt="1rem">
          <ButtonCmp VarColor="c6" onClick={onClose}>Cancelar</ButtonCmp>
          {Item && <ButtonCmp VarColor="Green2" onClick={() => onCreate(Item)}>Confirmar</ButtonCmp>}
        </Flex>
      </WhiteModal>
    </Modal>
  )
}
